import {
	type DataFromDetails,
	fromDetails,
} from 'maps/services/dto/fromDetails'
import type { Store } from 'maps/types'
import { ENDPOINT_STORES_FINDER } from 'maps/utils/constants'
import { fetcher } from 'services/rest/fetcher'
import { env } from 'utils/envManager/envManager'

const STORE_ID_LENGTH = 8
const STORE_ID_FILLER = '0'

interface GetStoreDetailProps {
	id: string
	countryISO: string
	languageISO: string
	channel: string
}

export async function getStoreDetail({
	id,
	countryISO,
	languageISO,
	channel,
}: GetStoreDetailProps): Promise<Store | null> {
	const storeId = id.padStart(STORE_ID_LENGTH, STORE_ID_FILLER)
	try {
		const url = new URL(
			`${ENDPOINT_STORES_FINDER}/${storeId}`,
			env.NEXT_PUBLIC_SITE_BASE_URL
		)
		url.search = new URLSearchParams({
			country: countryISO.toUpperCase(),
			language: languageISO.toUpperCase(),
			channel,
		}).toString()

		const res = await fetcher<{ stores: DataFromDetails[] }>(url.href)

		return fromDetails(res.stores[0])
	} catch (error) {
		console.error(`[Maps] Error fetching store detail: ${error}`)
	}

	return null
}
